import ImageFeature from './image_feature';
export default ImageFeature;
